import { render, staticRenderFns } from "./RTFooter.vue?vue&type=template&id=c89b9e4e&scoped=true&"
import script from "./RTFooter.vue?vue&type=script&lang=js&"
export * from "./RTFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b9e4e",
  null
  
)

export default component.exports